import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { CandidateSelectionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCandidateSelectionForm from "./components/AddCandidateSelectionForm";
import fields from "../json/CandidateSelection.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import {
    Create,
    GetAllCandidates,
    GetAllPositions
} from "adminApi/CandidateSelectionApi/CandidateSelection.js";

const AddCandidateSelection = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    //initialValues 
    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    //useFormChange
    const {
        values,
        errors,
        handleChange,
        setErrors
    } = useFormChange(
        initialValues,
        CandidateSelectionRules
    );

    // Fetch Candidates
    const {
        data: CandidateOptions = []
    } = useFetchAllData(
        GetAllCandidates
    );



    // Fetch Positions
    const {
        data: PositionOptions = []
    } = useFetchAllData(
        GetAllPositions
    );

    // form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, CandidateSelectionRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Candidate Selection Created Successfully"
    )
    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddCandidateSelectionForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                CandidateOptions={CandidateOptions}
                PositionOptions={PositionOptions}
            />
        </>
    );
};

export default AddCandidateSelection;
